import type { WhatsNewPayload } from "domains/whatsNew/types";

export enum WhatsNewActionType {
  FETCH = "[Whats new] - Fetch",
  FETCH_FULFILLED = "[Whats new] - Fetch Fulfilled",
  FETCH_REJECTED = "[Whats new] - Fetch Rejected",
}

export type FetchWhatsNewAction = { type: WhatsNewActionType.FETCH };
export type FetchWhatsNewActionFulfilled = { payload: WhatsNewPayload; type: WhatsNewActionType.FETCH_FULFILLED };
export type FetchWhatsNewActionRejected = { type: WhatsNewActionType.FETCH_REJECTED };

export type WhatsNewAction = FetchWhatsNewAction | FetchWhatsNewActionFulfilled | FetchWhatsNewActionRejected;
